import { TableSortLabel } from "@mui/material";

export type MUIDataTableSortOrder = { name: string; direction: "asc" | "desc" };

export const MakeSortableHead: React.FC<{
  columnMeta: any;
  sortOrder?: MUIDataTableSortOrder;
  children: React.ReactNode;
}> = ({ columnMeta, sortOrder, children }) => {
  const isActive = !!(sortOrder && sortOrder.name === columnMeta.name);
  const direction: "asc" | "desc" = isActive ? (sortOrder!.direction as "asc" | "desc") : "asc";

  return (
    <TableSortLabel active={isActive} direction={direction}>
      {children}
    </TableSortLabel>
  );
};